import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "../Auth/auth.css";

const StartupPage = () => {
  const navigate = useNavigate();

  const handlePlatformSelect = (platform) => {
    if (platform === "self") navigate("/register");
    else navigate("/register/organization");
  };

  const platformOptions = [
    {
      id: "org",
      title: "Organization LMS",
      tagline: "For companies and institutes managing structured training.",
      icon: "fas fa-building",
      features: [
        "Manager and employee hierarchies",
        "Training groups for course batches and campaigns",
        "Your own mentors for learner support and guidance",
        "Advanced role and permission controls",
        "Live progress monitoring and performance analytics",
        "Skill gap analysis and personality assessments",
        "Custom course builder, branding and certificates",
      ],
    },
    {
      id: "self",
      title: "Self Learning Hub",
      tagline: "For individuals learning at their own pace.",
      icon: "fas fa-user-graduate",
      features: [
        "Learn anytime, anywhere",
        "Track your progress and assessments",
        "Free courses available",
        "Earn certificates",
        "Personality and skill development tools",
      ],
    },
  ];

  return (
    <div className="ciq-startup">
      <div className="ciq-startup__bg" />
      <div className="ciq-startup__inner">
        <a className="ciq-brand ciq-startup__brand" href="https://coreiqpro.com">
          <img src={`${process.env.PUBLIC_URL}/logo-icon.png`} alt="CoreIQPro" />
          <span className="ciq-brand__txt">
            Core<span className="o">IQ</span>Pro
          </span>
        </a>

        <h1 className="ciq-startup__headline">Choose your learning journey</h1>
        <p className="ciq-startup__sub">
          Two ways to learn with CoreIQPro. Choose the one that fits you best.
        </p>

        <div className="ciq-startup__grid">
          {platformOptions.map((p, i) => (
            <motion.button
              type="button"
              key={p.id}
              className="ciq-startup__card"
              onClick={() => handlePlatformSelect(p.id)}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
            >
              <span className="ciq-startup__icon">
                <i className={p.icon} />
              </span>
              <h2 className="ciq-startup__card-title">{p.title}</h2>
              <p className="ciq-startup__card-tag">{p.tagline}</p>
              <ul className="ciq-startup__features">
                {p.features.map((f, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check" /> {f}
                  </li>
                ))}
              </ul>
              <span className="ciq-startup__cta">
                Get started <i className="fas fa-arrow-right" />
              </span>
            </motion.button>
          ))}
        </div>

        <p className="ciq-startup__foot">
          Already have an account?{" "}
          <button type="button" className="ciq-startup__link" onClick={() => navigate("/login")}>
            Log in
          </button>
        </p>
      </div>
    </div>
  );
};

export default StartupPage;
